import React from 'react';
import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';
import { formatDecimal } from 'utils/formatter';
import * as clevertapCapital from 'clevertap/capital';
import { clickApplyLoanList } from 'actions/capital';
import * as _ from 'lodash';
import styles from './ListLenders.css';
import PromoLink from '../Component/PromoLink';

class ListLenders extends React.Component {
  constructor(props) {
    super(props);
    const {
      capitalForm: { duration, pre_approved_amount: amount, lender_name: name },
    } = props;
    const objState = {
      // short for "module" but that's a keyword in js, so "mod"
      approvals: _.orderBy(props.approvals, ['maxLoan'], ['desc']),
      tenor: !duration || duration === '' ? 12 : duration,
      errorMessage: "The value can't be empty",
      amount_koinworks: '',
      amount_taralite: '',
      amount_modalku: '',
      sort: { name: '', asc: true },
    };
    this.state = updateAmountByVendorName(name, amount, objState);
  }

  componentWillReceiveProps(nextProps) {
    const {
      capitalForm: { duration, pre_approved_amount: amount, lender_name: name },
    } = nextProps;
    let objToChange = { ...this.state };
    objToChange.approvals = nextProps.approvals;
    objToChange.tenor =
      !duration || duration === '' ? nextProps.loanPeriod[0] : duration;
    objToChange = updateAmountByVendorName(name, amount, objToChange);
    this.setState({ ...objToChange });
  }

  render() {
    const { approvals } = this.state;
    const filteredapprovals = [];
    approvals.forEach(approval => {
      if (approval.tenor.toString() === this.state.tenor.toString()) {
        filteredapprovals.push(approval);
      }
    });
    return (
      <div className={styles.wrapper}>
        <table className={`table-responsive ${styles['table-header']}`}>
          <thead className={`${styles['thead-header']}`}>
            <tr valign="middle" className={`${styles['th-header']}`}>
              <th className={`text-left ${styles['td-lender-logo']}`} />
              <th className={`text-left ${styles['td-lender-name']}`}>
                Lender
                <a
                  onClick={() => {
                    this._sortBy('name');
                  }}
                  className={`${
                    this.state.sort.name === 'name' ? styles.sorted : ''
                  } ${styles['sorting-icon']}`}
                >
                  <i className={`fa fa-sort`} />
                </a>
              </th>
              <th className={`text-center ${styles['td-lender-amount']}`}>
                Max Loan Amount
                <a
                  onClick={() => {
                    this._sortBy('maxLoan');
                  }}
                  className={`${
                    this.state.sort.name === 'maxLoan' ? styles.sorted : ''
                  } ${styles['sorting-icon']}`}
                >
                  <i className={`fa fa-sort`} />
                </a>
              </th>
              <th className={`text-center ${styles['td-lender-rate']}`}>
                Interest Rate per annum
                <br />
                (starting at)
                <a
                  onClick={() => {
                    this._sortBy('rate');
                  }}
                  className={`${
                    this.state.sort.name === 'rate' ? styles.sorted : ''
                  } ${styles['sorting-icon']}`}
                >
                  <i className={`fa fa-sort`} />
                </a>
              </th>
              <th className={`text-center ${styles['td-lender-tenor']}`}>
                Tenure
                <select
                  onChange={this._onChangeTenor}
                  name="categoryId"
                  className={`${styles.select}`}
                  id="filterSelectCategory"
                >
                  {this.props.loanPeriod.map(tenor => {
                    return (
                      <option
                        value={tenor}
                        selected={this.state.tenor === tenor}
                        key={tenor}
                      >
                        {tenor} Months
                      </option>
                    );
                  })}
                </select>
              </th>
            </tr>
          </thead>
        </table>
        <div
          className={`col-md-12 ${styles['no-padding']} ${styles['box-list']} ${
            styles['box-scroll']
          }`}
        >
          {filteredapprovals.length > 0 &&
            filteredapprovals.map((approval, index) => {
              let numberValue = this.state[
                `amount_${approval.name.toLowerCase()}`
              ].replace(/\./g, '');
              numberValue = numberValue === '' ? 0 : numberValue;
              const loanapplied =
                numberValue === '0' || numberValue === 0
                  ? approval.maxLoan
                  : numberValue;
              const monthlyInstallment = Math.round(
                loanapplied / approval.tenor +
                  (approval.rate / 100 / 12) * loanapplied
              );
              return (
                <div
                  className={`col-md-12 ${styles['div-body']} spacer`}
                  key={index}
                >
                  <div className={`col-md-12 ${styles['box-body']}`}>
                    <div className={`${styles['box-lender-logo']}`}>
                      {' '}
                      <img
                        src={approval.logo}
                        className={`${styles['logo-lender']}`}
                      />
                    </div>
                    <div className={`${styles['box-lender-name']}`}>
                      <label className={`${styles['lender-name']}`}>
                        {approval.name}
                      </label>
                    </div>
                    <div className={`${styles['box-lender-amount']}`}>
                      IDR {formatDecimal(approval.maxLoan)}
                    </div>
                    <div className={`${styles['box-lender-rate']}`}>
                      {approval.rate}%
                    </div>
                    <div className={`${styles['box-lender-tenor']}`}>
                      <a
                        onClick={() => {
                          this._onClickApply(
                            approval.index,
                            approval.maxLoan,
                            approval.minLoan,
                            monthlyInstallment
                          );
                        }}
                        className={`btn ${styles['btn-apply-now']}`}
                      >
                        Apply Now
                      </a>
                    </div>
                  </div>
                  <div className={`col-md-12 ${styles['box-apply']}`}>
                    <hr className={`${styles['hr-line']}`} />
                    <div className={`col-md-12 ${styles['no-padding']}`}>
                      <div className={`col-md-3 ${styles['no-padding']}`}>
                        <div className={`col-md-12 ${styles['no-padding']}`}>
                          <label>Loan Amount</label>
                        </div>
                        <div
                          className={`text-center col-md-12 ${
                            styles['no-padding']
                          }`}
                        >
                          <div className="input-group">
                            <span
                              className={`input-group-addon ${
                                styles['input-rp']
                              } ${
                                approval.notValid !== '' ? styles.error : ''
                              }`}
                            >
                              Rp
                            </span>
                            <input
                              onChange={event => {
                                this._handleChange(
                                  event,
                                  approval.maxLoan,
                                  approval.minLoan,
                                  approval.index
                                );
                              }}
                              onKeyPress={this._onKeyPress}
                              value={
                                this.state[
                                  `amount_${approval.name.toLowerCase()}`
                                ]
                              }
                              type="text"
                              className="form-control"
                              name="name"
                              id="name"
                              placeholder={formatDecimal(approval.maxLoan)}
                            />
                          </div>
                          {approval.notValid !== '' && (
                            <span className={`${styles.error}`}>
                              {approval.notValid}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className={`text-center col-md-3`}>
                        <div className={`col-md-12`}>
                          <label>Tenure</label>
                        </div>
                        <div
                          className={`col-md-12 ${
                            styles['margin-description']
                          }`}
                        >
                          <span>{approval.tenor} months</span>
                        </div>
                      </div>
                      <div className={`text-center col-md-3`}>
                        <div className={`col-md-12`}>
                          <label>Monthly Instalment</label>
                        </div>
                        <div
                          className={`col-md-12 ${
                            styles['margin-description']
                          }`}
                        >
                          <span>
                            IDR {formatDecimal(monthlyInstallment)}/Month
                          </span>
                        </div>
                      </div>
                      <div
                        className={`col-md-3 ${
                          styles['no-padding']
                        }  text-right`}
                      >
                        <a
                          className={`btn ${styles['btn-more-info']}`}
                          onClick={e => {
                            this._onOpenMore(e, approval.index);
                          }}
                        >
                          {approval.isOpen
                            ? 'Hide Information'
                            : 'More Information'}
                        </a>
                      </div>
                    </div>
                  </div>
                  <div
                    hidden={approval.lenderPromotionTitle === ''}
                    className={`col-md-12 ${styles['box-apply']}`}
                  >
                    {' '}
                    <i className={`fa fa-tags`} />
                    <label>Promotion : </label>
                    <PromoLink
                      value={approval.index}
                      notes={approval.lenderPromotionTitle}
                      onLinkClick={this._onPromotion}
                    />
                  </div>
                  <div
                    className={`col-md-12 ${styles['no-padding']} ${
                      styles['bg-grey']
                    } ${styles['box-description']} ${styles.transform} ${
                      approval.isPromoOpen ? styles['transform-active'] : ''
                    }`}
                  >
                    {approval.isPromoOpen && (
                      <div className={`col-md-12`}>
                        <div
                          className={`col-md-12 ${styles['term-condition']}`}
                        >
                          Terms and Conditions
                        </div>
                        {approval.lenderPromotionTnC &&
                          approval.lenderPromotionTnC.map(
                            (promotionNote, index) => {
                              return (
                                <div
                                  className={`col-md-12 ${
                                    styles['display-table']
                                  } ${styles['no-padding']}`}
                                  key={index}
                                >
                                  <ul className={`${styles['ul-description']}`}>
                                    <li
                                      className={`${styles['float-left']} ${
                                        styles.checklist
                                      }`}
                                    >
                                      <span className="glyphicon glyphicon-play-circle" />
                                    </li>
                                    <li
                                      className={`${styles['float-left']} ${
                                        styles['description-check']
                                      }`}
                                    >
                                      {promotionNote}
                                    </li>
                                  </ul>
                                </div>
                              );
                            }
                          )}
                      </div>
                    )}
                  </div>
                  <div
                    className={`col-md-12 ${styles['no-padding']} ${
                      styles['bg-grey']
                    } ${styles['box-description']} ${styles.transform} ${
                      approval.isOpen ? styles['transform-active'] : ''
                    }`}
                  >
                    {approval.isOpen && (
                      <div className={`col-md-6`}>
                        <div
                          className={`col-md-12 ${styles['display-table']} ${
                            styles['no-padding']
                          }`}
                        >
                          <ul className={`${styles['ul-description']}`}>
                            <li
                              className={`${styles['float-left']} ${
                                styles.checklist
                              }`}
                            >
                              <span className="glyphicon glyphicon-ok" />
                            </li>
                            <li
                              className={`${styles['float-left']} ${
                                styles['description-check']
                              }`}
                            >
                              {approval.checklist1}
                            </li>
                          </ul>
                        </div>
                        <div
                          className={`col-md-12 ${styles['display-table']} ${
                            styles['no-padding']
                          }`}
                        >
                          <ul className={`${styles['ul-description']}`}>
                            <li
                              className={`${styles['float-left']} ${
                                styles.checklist
                              }`}
                            >
                              <span className="glyphicon glyphicon-ok" />
                            </li>
                            <li
                              className={`${styles['float-left']} ${
                                styles['description-check']
                              }`}
                            >
                              {approval.checklist2}
                            </li>
                          </ul>
                        </div>
                      </div>
                    )}
                    {approval.isOpen && (
                      <div className={`col-md-6`}>
                        <div className={`col-md-12 ${styles.disclaimer}`}>
                          Disclaimer
                        </div>
                        <div
                          className={`col-md-12 ${styles['desc-disclaimer']} ${
                            styles['description-check']
                          }`}
                        >
                          {approval.disclaimer}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    );
  }

  _onPromotion = param => {
    const { approvals } = this.state;
    const approval = approvals.find(approval => approval.index === param);
    if (approval) {
      approval.isPromoOpen = !approval.isPromoOpen;
      this.setState({ approvals });
    }
  };

  _sortBy = param => {
    if (this.state.sort.asc) {
      this.setState({
        approvals: _.orderBy(this.state.approvals, [param], ['desc']),
        sort: { name: param, asc: false },
      });
    } else {
      this.setState({
        approvals: _.orderBy(this.state.approvals, [param], ['asc']),
        sort: { name: param, asc: true },
      });
    }
  };

  _onOpenMore = (e, id) => {
    const { approvals } = this.state;
    const idx = _.findIndex(approvals, ['index', id]);
    if (!approvals[idx].isOpen) {
      clevertapCapital.showDetail({
        lenderName: approvals[idx].name,
        tenure: approvals[idx].tenor,
        rate: approvals[idx].rate,
        maxAmount: approvals[idx].maxLoan,
      });
    }
    approvals[idx].isOpen = !approvals[idx].isOpen;
    this.setState({ approvals });
  };

  _onKeyPress = e => {
    if (e.key === 'Enter') {
      e.preventDefault();
    }
  };

  _onClickApply = (id, max, min, monthlyInstallment) => {
    const { approvals } = this.state;
    const idx = _.findIndex(approvals, ['index', id]);
    const {
      capitalForm: { lender_name: lenderName },
      borrowerProfile,
    } = this.props;
    const amountLoan = this.state[
      `amount_${approvals[idx].name.toLowerCase()}`
    ];
    const resetForm = lenderName !== approvals[idx].name;
    const numberValue = amountLoan.replace(/\./g, '');
    const loansType = this.props.capitalForm.loans_Type;
    approvals[idx].notValid = validateLoanAmount(numberValue, max, min);
    if (approvals[idx].notValid === '' && amountLoan !== '') {
      approvals[idx].preApproveLoan = amountLoan;
      this.props.dispatch(
        clickApplyLoanList({
          ...approvals[idx],
          monthlyInstallment,
          resetForm,
          borrowerProfile,
          loansType,
        })
      );

      const selectedLoan = {
        tenure: approvals[idx].tenor,
        rate: approvals[idx].rate,
        amount: approvals[idx].preApproveLoan,
        maxLoan: approvals[idx].maxLoan,
        lender: approvals[idx].name,
      };
      clevertapCapital.capitalClickApplyNow(selectedLoan);
    } else {
      this.setState({ approvals });
    }
  };

  _onChangeTenor = event => {
    clevertapCapital.changeTenure(event.target.value);
    this.setState({ tenor: event.target.value });
  };

  _handleChange(event, max, min, id) {
    let numberValue = event.target.value.replace(/\./g, '');
    numberValue = numberValue.replace(/\D/g, '');
    const { approvals } = this.state;
    const idx = _.findIndex(approvals, ['index', id]);
    const displayNumber = formatDecimal(numberValue);
    approvals[idx].notValid = validateLoanAmount(numberValue, max, min);
    const obj = {
      approvals,
      errorMessage: `Maximum value is ${formatDecimal(max)}`,
    };
    if (approvals[idx].name === 'KoinWorks') {
      obj.amount_koinworks = displayNumber;
    } else if (approvals[idx].name.toLowerCase() === 'taralite') {
      obj.amount_taralite = displayNumber;
    } else if (approvals[idx].name.toLowerCase() === 'modalku') {
      obj.amount_modalku = displayNumber;
    }

    this.setState({ ...obj });
  }
}

function mapStateToProps(state) {
  const { approvals, borrowerProfile, loanPeriod } = state.capital;
  return {
    approvals,
    borrowerProfile,
    loanPeriod,
    capitalForm: getFormValues('mokaCapital')(state),
  };
}

export default connect(mapStateToProps)(ListLenders);

// helper
function updateAmountByVendorName(name, amount, objState) {
  const newObjState = { ...objState };
  switch (name.toLowerCase()) {
    case 'koinworks':
      newObjState.amount_koinworks = formatDecimal(amount);
      break;
    case 'taralite':
      newObjState.amount_taralite = formatDecimal(amount);
      break;
    case 'modalku':
      newObjState.amount_modalku = formatDecimal(amount);
      break;
  }
  return newObjState;
}

function validateLoanAmount(numberValue, max, min) {
  if (!isNaN(numberValue) || numberValue === '') {
    if (numberValue === '') {
      return "The value can't be empty";
    }
    if (numberValue[0] === '0') {
      return 'Please enter a valid amount';
    }
    if (numberValue > max) {
      return `Maximum value is ${formatDecimal(max)}`;
    }
    if (min > numberValue) {
      return `Minimum value is ${formatDecimal(min)}`;
    }
    if (numberValue % 100000 !== 0) {
      return 'The value must be  multiple of 100.000';
    }
    return '';
  }
  return 'Only is number accepted';
}
